<template>
  <div class="details" id="apply">
    <header>
      <div class="search">
        <router-link :to="{ name: 'Live' }"
          ><img src="../../assets/images/logo.jpg" alt=""
        /></router-link>
      </div>
    </header>
    <div class="details_wrap" ref="details_wrap" v-if="videoData">
      <div class="video_ichat">
        <i-player
          ref="player"
          style="width: 860px; height: 483px; overflow: hidden"
          :videoinfo="videoData"
          @funisCharge="funisCharge"
          :isCharge="isCharge"
          :isCanPlay="isCanPlay"
          v-on:ok="ok"
        >
        </i-player>
        <div class="menus">
          <div v-if="this.$route.query.type == 'live'" class="livetitle">
            <div class="title">
              <div class="name">
                {{ videoData.vTitle ? videoData.vTitle : "" }}
              </div>
              <p v-if="videoData.lState == 1">
                <span class="live_line">在线人数：</span>
                <span class="live_num">{{ num }}人</span>
              </p>
              <p v-if="videoData.vCreateDt && videoData.lState != 1">
                直播时间：{{ getTimes(videoData.vCreateDt) }}
                <span
                  class="live_line"
                  style="margin-left: 50px"
                  v-if="videoData.lState == 1"
                  >预约人数：</span
                >
                <span class="live_num" v-if="videoData.lState == 1"
                  >{{ videoData.lAppointNum }}人</span
                >
              </p>
            </div>
            <div>
              <div
                class="people"
                v-if="this.$route.query.type == 'live' && videoData.lState == 0"
              >
                <!--<span>预约人数：{{videoData.lAppointNum}}人</span>-->
                <button
                  class="footer_yybm"
                  @click="signUp(sing)"
                  :style="{ background: sing == 1 ? '#999999' : '#F18C20' }"
                >
                  {{ text }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right_chat">
        <ul v-if="this.$route.query.type == 'live'" class="uls">
          <li
            @click="tolink(i)"
            :class="[
              i == index ? 'active' : '',
              videoData.lState == 0 || videoData.lState == 1
                ? 'threemodal'
                : 'twomodal',
            ]"
            v-for="(item, i) in menuslist"
          >
            {{ item.name }}
          </li>
        </ul>
        <div
          class="content_live"
          :style="{
            height: videoData.formatfl == 1 && isployvPlay ? '326px' : '524px',
          }"
        >
          <div
            v-if="index == 0"
            class="content_lecturer"
            :style="{
              height:
                videoData.formatfl == 1 && isployvPlay ? '306px' : '504px',
            }"
          >
            <div
              v-if="
                videoData.vDesc != undefined &&
                videoData.vDesc != null &&
                videoData.vDesc != ''
              "
              v-html="videoData.vDesc"
            ></div>
            <i-lecturer :value="videoData.teacher" v-else></i-lecturer>
          </div>
          <div
            v-show="
              index == 1 && (videoData.lState == 0 || videoData.lState == 1)
            "
          >
            <i-chat
              style="position: relative; width: 100%; height: 100%"
              v-on:onlineuser="onlineuser"
              v-on:startquestion="startquestion"
              :manager="manager"
              :channel="videoData.channel"
              :isployvPlay="isployvPlay"
              :formatfl="videoData.formatfl"
              v-on:question="question"
              v-on:cancelquestion="cancelquestion"
            ></i-chat>

            <div
              id="wrap"
              style="position: absolute; top: -40px; bottom: 0"
            ></div>
          </div>

          <div
            v-show="
              index == 2 || videoData.lState == 2 || videoData.lState == 3
            "
            class="photo"
          >
            <div v-if="!isCharge">
              <photo v-if="pptlist.length > 0" :imgs="pptlist"></photo>
              <img
                src="../../assets/images/nothing.png"
                alt
                v-else
                class="nothing"
              />
            </div>
            <div v-else class="limits">
              <img src="../../assets/images/chahua.png" alt />
              <div class="a">
                <span>您尚未购买课程，购买课程后才能观看</span>
              </div>
            </div>

            <div class="buyCC" v-if="isCharge" @click="subscribe()">
              <span>购买课程</span>
              <span v-if="curPrice">¥{{ curPrice }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showimg" class="showimg" @click="cancelshowimg">
      <img :src="imgurl" alt="" />
    </div>
    <div v-if="sharecontent" class="sharecontent" @click="sharecontent = false">
      <img src="../../assets/images/share.png" alt="" />
    </div>

    <!--支付二维码弹框-->
    <!--      v-show="payqrcode"
-->

    <el-dialog
      title="支付提示"
      :visible.sync="payqrcode"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div style="text-align: center" v-if="payqrcode">
        <p>支付金额：{{ this.curPrice }}元</p>
        <p>购买此课程，需微信扫码支付。</p>
        <!-- 直播回顾需要展示此提示语 -->
        <p v-if="$route.query.tip=='ed'">购买后有效期半年可看</p>
        <div id="con_qrcode" ref="qrcode"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import iLecturer from "../container/lecturer";
import iCourse from "../container/course";
import iChat from "../iChat/iChat_old";
import iPlayer from "../container/player";

import MD5 from "@/assets/js/md5";

import weui from "weui.js";
import bus from "../bus/index";
import photo from "./photo";
import QRCode from "qrcodejs2"; //二维码

import $ from "jquery";
import loginService from "../../plugin/extendFn/loginService";
import { resolve } from "q";
import AppSetting from '../../AppSetting';

export default {
  data() {
    return {
      isVipBuy: 0,
      timer: null,
      curPrice: "",
      isshow: false,
      pptlist: [],
      sharecontent: false,
      active: this.$route.query.type == "live" ? 0 : 0,
      // pptList:{},
      videoData: null,
      menuslist: [],
      index: 0,
      sing: 0,
      text: "预约报名",
      texts: "收藏",
      anlist: [],
      boxheight: "",
      teacher: this.$route.query.type == "live" ? "1" : "0",
      list: [],
      video_newest: null,
      // lessonInfo:null,
      ra_wxUser: null,
      isQuestion: false,
      issuccessinfo: false,
      answer: [],
      rightanswer: [],
      socket: "",
      name: "",
      org: "",
      hasNameOrg: "",
      imgurl: "",
      showimg: false,
      homeicon: true,
      ismember: false,
      num: "0",
      position: {
        bottom: 50,
        right: 27,
      },
      clientX: "",
      clientY: "",
      topHeight: "",
      fl: "",
      onpresscTime: 0, //  阻止短时间内连续点击
      manager: null,
      questfl: null,
      sign: "",
      timestamp: "",
      videoToken: "",
      mediaChannelKey: "",
      liveSdk: null,
      isployvPlay: false,
      payqrcode: false,
      payfl: 0,

      interval: 0,
      isCanPlay: null,
    };
  },
  props: ["ClassTimePlayer", "videoUrl"],
  components: {
    iLecturer,
    iCourse,
    iChat,
    iPlayer,
    photo,
  },
  created() {
    this.$waiting.show(3);
  },
  methods: {
    funisCharge(type) {
      if (type == 1) {
        //需要支付
        this.subscribe();
      }
    },
    handleClose() {
      document.getElementById("con_qrcode").innerHTML = "";
      this.payqrcode = false;
      this.payfl = 0;
      window.clearInterval(this.timer);
    },
    //购买课程
    async subscribe() {
      if (this.payfl == 1) {
        this.$message.warning("请勿重复点击！");
        return false;
      }

      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        let ra_wxUser = await loginService.getLoginUser();

        console.log("微信登录信息----", ra_wxUser);
        if (ra_wxUser.uMemberType) {
          if (this.isfree == "1") {
            this.curPrice = 0;
          }
        }
        if (ra_wxUser.uPhone && ra_wxUser.uOrg) {
          this.payfl = 1;
          if (this.curPrice == 0) {
            //0元不需要显示二维码 直接生成订单
            this.payqrcode = false;
          } else {
            this.payqrcode = true;
          }

          let param = {
            type: 1,
            orderType: this.$route.query.type == "live" ? 2 : "", //vip购买，1 视频购买，2直播购买，3专栏购买
            bId:
              this.$route.query.type == "live" ? this.$route.query.liveId : "",
            payPrice: this.curPrice,
            uid: ra_wxUser.uId,
            isVipBuy: this.isVipBuy,
          };
          this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then((res) => {
            if (res.data.code == 0) {
              if (this.curPrice == 0) {
                //this.$message.success('支付成功！');
                //location.reload()
                this.videoData.buyed = true;
                this.playLive();
                return false;
              }
              const pay_params = JSON.parse(res.data.parMap);
              const orderid = res.data.id; //订单号 用于查询支付状态
              console.log("支付信息", pay_params);
              let qrcode = new QRCode(this.$refs.qrcode, {
                text: pay_params.code_url,
                width: 200,
                height: 200,
                colorDark: "#333333", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
              });

              this.timer = setInterval(() => {
                this.$postHttp(AppSetting.baseUrl + "/order/app/search", {
                  id: orderid,
                }).then((result) => {
                  console.log(result);
                  if (result.data.code == 0) {
                    //data.orderStatus 0未支付，1支付成功，2支付失败
                    if (result.data.data.orderStatus == 1) {
                      this.$message.success("支付成功！");
                      document.getElementById("con_qrcode").innerHTML = "";
                      window.clearInterval(this.timer);
                      location.reload();
                      this.payqrcode = false;
                    } else if (result.data.data.orderStatus == 2) {
                      this.$message.success("支付失败！");
                      window.clearInterval(this.timer);
                      document.getElementById("con_qrcode").innerHTML = "";
                      this.payqrcode = false;
                    }
                  } else if (result.data.code == 2004) {
                    this.$message.error("订单号为空");
                  } else {
                    this.$message.error("查询失败");
                  }
                });
              }, 2000);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      }
    },
    tolink(type) {
      if (type == 2 && this.isCharge) {
        //ppt  判断是否需要付费

        this.subscribe();
      } else {
        this.index = type;
      }
    },
    cancelquestion(val) {
      //
      console.log("取消弹框", val);
      this.isQuestion = val;
    },
    question(val) {
      console.log("接口是否已答题状态");
      this.questfl = val;
    },
    startmanager(type) {
      console.log("触发开始答题按钮");
      this.manager = type;
      this.questfl = type;
    },
    onlineuser(data) {
      this.num = data;
    },
    startquestion(val) {
      this.isQuestion = val;
    },
    cancelMember() {
      this.ismember = false;
    },
    cancelshowimg() {
      this.showimg = false;
      this.issuccessinfo = false;
    },
    ok(val) {
      if (val == "success") {
        if (this.anlist.length < 1) {
          //没有题目
          this.isQuestion = false;
        } else {
          if (this.$route.query.type == "video") {
            //有题目 是否答题  是否领取证书
            if (this.videoData.vIsComplete == 0) {
              //未答题
              // bus.$emit('isstop','stop')
              this.isQuestion = true;
            } else if (this.videoData.vIsComplete == 1) {
              //已答题
              this.isQuestion = false;
            }
          } else {
            //直播  直播也有问卷调查差
            //有题目 是否答题  是否领取证书
            if (this.videoData.vIsComplete == 0) {
              //未答题
              // bus.$emit('isstop','stop')
              this.isQuestion = true;
            } else if (this.videoData.vIsComplete == 1) {
              //已答题
              this.isQuestion = false;
              // if(this.videoData.vIsCredential==0){//未领取证书
              //   // bus.$emit('isstop','stop')
              //   this.issuccessinfo = true;
              // }else{
              //
              // }
            }
          }
        }
      }
    },
    login() {
      return new Promise((resolve, reject) => {
        loginService
          .login(this.$router)
          .then((loginUser) => {
            this.ra_wxUser = loginUser;
            resolve(loginUser);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async signUp(status) {
      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        this.ra_wxUser = await loginService.getLoginUser();

        if (status == 0) {
          this.$postHttp(AppSetting.baseUrl + "/live/appointment", {
            uid: this.ra_wxUser.uId,
            lid: this.$route.query.liveId,
          }).then((res) => {
            if (res.data.code == 0) {
              this.$set(this.videoData, "lAppointNum", res.data.num);
              this.text = "已预约";
              this.sing = 1;
              this.$message.success("预约成功");
            } else {
              this.$message.error("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {
                  // alert('取消')
                },
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/live/appointment/cancel", {
                    uid: this.ra_wxUser.uId,
                    lid: this.$route.query.liveId,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.$set(this.videoData, "lAppointNum", res.data.num);
                      this.text = "预约报名";
                      this.sing = 0;
                      this.$message.success("取消成功");
                    } else {
                      this.$message.error("取消预约失败");
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },
    getTimes(value) {
      let val = new Date(value).getTime();
      return new Date(val).Format("yyyy.MM.dd hh:mm");
    },

    setInterval(dt, state) {
      let interval = 1000 * 30; // 60秒
      let now = new Date().getTime();
      let c = now - dt;
      if (Math.abs(c < 2 * 60 * 1000)) {
        // 绝对值小于2分钟时，设置每10秒钟跑一次
        interval = 1000 * 10;
      } else if (c < 5 * 60 * 1000 && c > 0) {
        // 小于5分钟时，设置每60秒钟跑一次
        interval = 1000 * 60;
      } else if (c > 5 * 60 * 1000) {
        // 大于5分钟时，设置每5分钟跑一次
        interval = 1000 * 60 * 5;
      }

      const tm = () => {
        this.getlivedetails();
      };
      this.interval = setTimeout(tm, interval);
    },

    playLive() {
      clearTimeout(this.interval);
      setTimeout(() => {
        this.$refs["player"].playVideo();
      }, 1000);
    },

    async getlivedetails() {
      // let res = await this.$postHttp('/live/online/update',{lid:this.$route.query.liveId,type:1})
      // console.log(res);
      this.$postHttp(AppSetting.baseUrl + "/live/detail", {
        lid: this.$route.query.liveId,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "0",
      }).then((res) => {
        if (res.data.code == 0) {
          // console.log(res);
          // this.fl = 1;//直播的话都显示
          this.videoData = res.data.live;
          this.isCanPlay = res.data.isCanPlay;
          this.videoData.showWatermark = res.data.showWatermark; // 是否展示水印功能
          this.$waiting.hide();
          this.videoData.channel = this.videoData.lChannelCode; //频道id
          console.log(this.videoData.channel);

          if (res.data.live.lState == 0 || res.data.live.lState == 1) {
            //即将直播  直播开始 显示互动讨论
            this.menuslist = [
              { name: "课程介绍" },
              { name: "互动讨论" },
              // { name: "PPT" },
            ];

            this.socket = io.connect(this.GLOBAL.SOCKETPORT); //生产端口
          } else {
            this.menuslist = [
              { name: "课程介绍" },
              //  { name: "PPT" }
              ];
          }

          this.curPrice = res.data.live.lFees; //现价

          if (res.data.isfree == "1") {
            this.isVipBuy = res.data.isfree;
            this.curPrice = "0";
          } else if (this.videoData.lIsCharge == "0") {
            //免费
            this.curPrice = "0";
          }

          this.videoData.formatfl = this.videoData.lFormat;
          this.videoData.vIsComplete = this.videoData.lIsComplete;
          this.lOrderFl = this.videoData.lOrderFl;
          this.videoData.vDesc = this.videoData.lDesc;
          // console.log('1111',this.videoData.vDesc);
          let illuma_isshow = localStorage.getItem(
            "illuma_isshow" + this.$route.query.liveId
          );
          if (this.videoData.lPasswordFl == 1 && illuma_isshow != 1) {
            this.isshow = true;
          }
          this.videoData.vCreateDt = this.videoData.lDt;
          this.videoData.vTitle = this.videoData.lTitle;
          this.videoData.vViewUrl = this.videoData.lViewUrl;
          this.sing = this.videoData.lIsAppoint == 1 ? 1 : 0;
          this.text = this.videoData.lIsAppoint == 1 ? "已预约" : "预约报名";

          // 直接中
          if (res.data.live.lState == 1) {
            this.playLive();
          } else if (res.data.live.lState == 0) {
            this.setInterval(this.videoData.lDt, res.data.live.lState);
          }

          this.$postHttp(AppSetting.baseUrl + "/live/ppt", {
            lid: this.$route.query.liveId,
            uid: this.ra_wxUser ? this.ra_wxUser.uId : "0",
          }).then((res) => {
            if (res.data.code == 0) {
              this.permissionsType = res.data.permissionsType;
              if (res.data.permissionsType == 2011) {
                //没有权限
              }
              if (res.data.permissionsType == 2012) {
                //收费观看
                // this.curPrice = res.data.permissionsType;
              }
              this.pptlist = res.data.list || [];
            }
          });
        }
      });
    },
  },
  computed: {
    isCharge() {
      let status = false;
      // 去掉了是否需要付款判断
      //if (this.videoData.lIsCharge == '1' && !this.videoData.buyed) {
      if (!this.videoData || !this.videoData.buyed) {
        status = true;
      }

      return status;
    },
  },
  async mounted() {
    this.ra_wxUser = await loginService.getLoginUser();
    
    this.$route.query.type = this.$route.query.type
      ? this.$route.query.type
      : "live";
    this.$route.query.liveId = this.$route.query.liveId
      ? this.$route.query.liveId
      : "";
    localStorage.setItem(
      "source",
      this.$route.query.source
        ? this.$route.query.source
        : this.$route.query.soucre
        ? this.$route.query.soucre
        : ""
    ); //小桔灯的链接给错了 先换上去
    localStorage.setItem(
      "userLiveId",
      this.$route.query.liveId
        ? this.$route.query.liveId
        : this.$route.query.videoId
        ? this.$route.query.videoId
        : ""
    );
    localStorage.setItem("usertype", this.$route.query.type == "live" ? 1 : 2);
    localStorage.setItem("share", "");
    await this.getlivedetails();
  },

  beforeRouteLeave(to, from, next) {
    //后台说不需要调用了
    // let res = this.$postHttp('/live/online/update',{lid:this.$route.query.liveId,type:0})
    //  console.log(res)
    // next();

    if (sessionStorage.getItem("ilnmtime") <= 0) {
      next();
    } else {
      if (this.ra_wxUser) {
        if (this.ra_wxUser.uPhone) {
          if (this.$route.query.type == "video") {
            let params = {
              vid: this.$route.query.videoId,
              uid: this.ra_wxUser ? this.ra_wxUser.uId : 0,
              time: sessionStorage.getItem("ilnmtime") * 1,
            };
            this.$postHttp(AppSetting.baseUrl + "/video/info/exit", params).then(
              (res) => {
                // console.log(res);

                if (res.data.code == 0) {
                  next();
                }
              }
            );
          } else {
            next();
          }
        } else {
          next();
        }
      } else {
        next();
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>
<style scoped lang="scss">
.nothing {
  width: 50%;
  display: block;
  margin: 30px auto;
}

#con_qrcode {
  width: 200px;
  height: 200px;
  margin: 20px auto;
  display: inline-block;
}

.photo {
  position: relative;
  overflow-y: scroll;
}

.buyCC {
  width: 100%;
  background: #05a2ff;
  position: absolute;
  bottom: 0px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  height: 40px;
  cursor: pointer;
}

.limits {
  img {
    width: 264px;
    height: 110px;
    margin-top: 50px;
  }

  margin: auto;
  font-size: 16px;
  color: #666666;
  text-align: center;
  line-height: 40px;

  .goMen {
    color: #5bb8f8;
  }
}

.desc {
  text-align: center;
}

#player {
  width: 406px;
  height: 200px;
}

.content_live {
  width: 406px;
  /*height: 326px;*/
  /*height: 524px;*/
  /*overflow-y: scroll;*/
  padding: 11px 9px 15px 11px;
  box-sizing: border-box;

  > div {
    height: 100%;
  }
}

.content_lecturer {
  width: 386px;
  height: 493px;
  overflow-y: scroll;
}

.content_live::-webkit-scrollbar {
  display: none;
}

.start {
  cursor: pointer;
  font-size: 15px;
  color: #f18c20;
  float: right;
  margin-top: 10px;
  margin-right: 50px;
}

.container_wrap {
  position: relative;
  overflow: hidden;

  .ul_wrap {
    width: 100%;
    margin-bottom: 20px;
  }

  .videolesson {
    font-size: 18px;
    height: 20px;
    font-weight: bolder;
    margin-top: 18px;
    line-height: 20px;
    margin-bottom: 15px;
    border-left: 5px solid #f18c20;
    padding-left: 4px;
  }

  .videolesson:before {
    /*content: '|';*/
    /*font-weight: bold;*/
    /*display: inline-block;*/
    /*width: 6px;*/
    /*color: #F18C20;*/
    /*margin-right: 4px;*/
  }
}

.text_desc {
  padding: 9px;
  box-sizing: border-box;
}

.right_chat {
  width: 406px;
  /*height: 614px;*/
  background: #f7f7f7;
  float: left;
  margin-left: 13px;

  .uls {
    width: 406px;
    font-size: 16px;
    color: #333333;
    background: rgba(241, 140, 32, 0.2);
    height: 40px;
    line-height: 40px;
    display: flex;

    li:nth-of-type(1):after {
      content: "|";
      color: #ffffff;
      position: absolute;
      right: -2px;
    }

    // li:nth-of-type(2):after {
    //   content: "|";
    //   color: #ffffff;
    //   position: absolute;
    //   right: -2px;
    // }

    li {
      cursor: pointer;
      position: relative;
      float: left;
      text-align: center;
      box-sizing: border-box;
      font-size: 16px;
    }
    li{
      flex-grow: 1;
    }

    // .threemodal {
    //   width: 33.3%;
    // }

    // .twomodal {
    //   width: 50%;
    // }
  }
}

.quesul {
  .title {
    p {
      font-size: 16px;
    }
  }
}

.toleft {
  position: absolute;
  width: 70px;
  height: 300px;
  background: rgba(0, 0, 0, 0.3);
  font-size: 42px;
  text-align: center;
  top: -10px;
  line-height: 300px;
  color: #ffffff;
  display: none;
  z-index: 2;
}

.toright {
  position: absolute;
  right: 0;
  top: -10px;
  width: 70px;
  height: 300px;
  background: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-size: 42px;
  text-align: center;
  line-height: 300px;
  display: none;
  z-index: 2;
}

.container_wrap:hover .toleft {
  display: block;
  cursor: pointer;
}

.container_wrap:hover .toright {
  display: block;
  cursor: pointer;
}

.container_item {
  /*float: left;*/
  margin-right: 16px;
  box-sizing: border-box;
  display: inline-block;
  background: #ffffff;
  width: 232px;
  margin-bottom: 16px;
  border: 1px solid #eeeeee;
  padding-top: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;

  .item_con {
    /*height: 111px;*/
    width: 212px;
    text-align: center;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;

    > div {
      border-radius: 5px;
      width: 212px;
      height: 120px;
      position: absolute;
      z-index: 1;
      background: rgba(0, 0, 0, 0.3);
      margin-left: 10px;
    }

    .con_images {
      width: 212px;
      margin-left: 10px;
      border-radius: 5px;
      height: 120px;
      display: block;
    }
  }

  .item_title {
    font-size: 14px;
    /*width: 202px;*/
    /*height: 57.6px;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333333;
  }

  .item_text {
    font-size: 12px;
    color: #666666;

    p:nth-of-type(2) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .num_type {
    font-size: 16px;
    line-height: 25px;
    height: 25px;

    p:nth-of-type(1) {
      float: left;
      line-height: 24px;
    }

    p:nth-of-type(2) {
      float: right;
    }

    img {
      margin-right: 5px;
      position: relative;
      top: 5px;
    }

    .see {
      width: 15px;
      height: 15px;
    }

    .lesson {
      width: 15px;
      height: 15px;
    }

    p span {
      font-size: 12px;
      color: #666666;
    }
  }
}

.container_item:nth-last-of-type(1) {
  margin-right: 0px;
}

.none {
  width: 100%;
  background: #ffffff;
  /*padding-top: 2.64rem;*/
  box-sizing: border-box;
  text-align: center;

  img {
    width: 1.96rem;
    height: 1.28rem;
    display: inline-block;
    margin: 1.09rem auto 0px;
    /*width: 100%;*/
  }

  p {
    font-size: 0.26rem;
    color: #999999;
    text-align: center;
  }
}

.anstitle {
  margin-top: 10px;
  font-size: 18px;
  position: relative;

  .desctip {
    font-size: 12px;
    position: absolute;
    left: 20px;
    top: 10px;
  }
}

.pswcontent {
  position: relative;

  input {
    height: 40px;
  }

  p {
    position: absolute;
    top: 60px;
    font-size: 24px;
    color: red;
  }
}

.relvideo {
  border-top: 1px solid #eeeeee;
  margin-top: 14px;
  width: 100%;

  .title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 34px;
    box-sizing: border-box;
    font-size: 16px;
    background: #fef4ec;
    margin-bottom: 16px;
  }
}

.videomore {
  margin-top: 14px;
  border-top: 1px solid #eeeeee;
  padding-top: 18px;
}

.ppt {
  float: left;
  font-size: 18px;
  /*height: 600px;*/
  box-sizing: border-box;
  /*overflow-y: scroll;*/
  .text_ppt {
    width: 384px;
    margin-top: 74px;
    background: #ffeec6;
    color: #333333;
    font-size: 16px;
    padding-left: 35px;
    line-height: 40px;
    height: 40px;
  }

  .pptwrap {
    width: 384px;
    height: 1150px;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
  }

  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

.footer {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-around;

  button {
    width: 105px;
    height: 39px;
    border-radius: 10px;
    border: none;
    font-size: 14px;
    font-weight: 500;
    outline: none;
    color: #ffffff;
    background: #ffb441;
  }
}

.psw {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #999999;
  outline: none;
  margin-bottom: 30px;
  padding: 0 20px;
  box-sizing: border-box;
}

.tips_content {
  width: 350px;
  height: 225px;
  border-radius: 10px;
  padding: 37px 43px;
  box-sizing: border-box;
  background: #ffffff;
  margin: 150px auto;

  > p {
    color: #333333;
    font-size: 16px;
    margin-bottom: 5px;
  }

  > div {
    font-size: 30px;

    span {
      display: inline-block;
      color: #999999;
    }

    > div {
      display: flex;
      padding-left: 20px;
      box-sizing: border-box;
      margin: 0 auto;

      > div {
        margin-bottom: 48px;
        border: 1px solid #999999;
        border-radius: 50%;
        width: 40px;
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: center;
        margin-right: 20px;

        > div {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
      }
    }
  }
}

.msgcontent {
  font-size: 24px;
}

.megp {
  display: flex;
  position: absolute;
  bottom: 50px;

  button {
    align-items: center;
    border: none;
    outline: none;
    color: #ffffff;
    width: 200px;
    height: 80px;
    text-align: center;
    border-radius: 5px;
  }

  button:nth-of-type(2) {
    margin-left: 10px;
    background: rgb(9, 131, 255);
  }
}

#apply {
  /*background: #F6F6F6;*/
  position: relative;
  width: 100%;

  > header {
    min-width: 1280px;
    width: 100%;
    height: 57px;
    background: #ffffff;
    border-bottom: 1px solid #a2a2a2;

    .search {
      width: 1280px;
      min-width: 1280px;
      margin: 0 auto;
      box-sizing: border-box;

      a {
        > img {
          width: 50px;
          display: block;
        }
      }
    }
  }

  .top,
  .top > a {
    width: 100%;
    height: 68px;
    display: inline-block;
    background: #ffffff;
    padding-left: 76px;
    line-height: 68px;

    img {
      width: 201px;
    }
  }

  .details_wrap {
    width: 1280px;
    min-width: 1280px;
    background: #ffffff;
    margin: 11px auto 0px;
    overflow: hidden;
    /*height: 6.42rem;*/
    flex-grow: 0;
    z-index: 1;

    .video_ichat {
      width: 860px;
      float: left;
    }

    .line {
      height: 20px;
      background: #f6f6f6;
    }
  }
}

.active {
  color: #f18c20 !important;
  border-bottom: 1px solid #f18c20;
  box-sizing: border-box;
}

.boxichat {
  background: #ffffff;
  flex-grow: 1;
  width: 100%;
  padding-top: 20px;
  height: 600px;
  position: relative;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  display: flex;
}

.box {
  background: #ffffff;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  display: flex;
}

.container {
  padding: 20px 30px;
  box-sizing: border-box;
  flex-grow: 1;
  /*width: 100vw;*/
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 0;
  overflow-y: scroll;
  /*会导致z-index失效*/

  -webkit-overflow-scrolling: touch;
}

.livetitle,
.live_title {
  height: 50px;

  .title {
    width: 720px;
  }

  > div {
    float: left;
  }
}

.videotitle {
  .title {
    width: 700px;
    float: left;
  }

  .img_text {
    float: left;
    font-size: 15px;
    cursor: pointer;
  }
}

.livetitle,
.videotitle {
  width: 100%;
  overflow: hidden;
  /*box-sizing: border-box;*/
  .title {
    /*padding-left: 20px;*/
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .live_line {
    color: #666666;
    font-size: 14px;
  }

  .live_num {
    color: #efbd87;
    font-size: 14px;
  }

  p {
    font-size: 14px;
    color: #666666;
  }

  .name {
    width: 650px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    white-space: nowrap;
  }
}

.menus {
  height: 80px;
  width: 100%;
  background: #f7f7f7;
  padding: 15px;
  box-sizing: border-box;
}

.tabmenus {
  display: flex;
  /*width: 7.5rem;*/
  width: 100%;
  height: 80px;
  background: #ffffff;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  font-size: 28px;
  color: #666666;
  align-items: center;
  z-index: 1;

  li {
    width: 246px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  li:nth-of-type(2) > span {
    display: inline-block;
    width: 246px;
    line-height: 30px;
    text-align: center;
    border-left: 1px solid #e6e6e6;
    /*border-right: 1px solid #E6E6E6;*/
  }

  .active {
    color: #ffb441;
    border-bottom: 1px solid #ffb441;
  }

  li:nth-of-type(3) > span {
    display: inline-block;
    width: 246px;
    line-height: 30px;
    text-align: center;
    border-left: 1px solid #e6e6e6;
    /*border-right: 1px solid #E6E6E6;*/
  }
}

.footer_yybm {
  width: 80px;
  height: 30px;
  flex-shrink: 0;
  font-size: 14px;
  /*background:linear-gradient(0deg,rgba(9,131,255,1) 0%,rgba(33,175,255,1) 100%);*/
  border-radius: 25px;
  color: #ffffff;
  border: none;
  outline: none;
  cursor: pointer;
}

.img_text {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  img {
    width: 20px;
    margin-right: 9px;
  }

  color: #666666;
}

#messageinfo {
  z-index: 1002;
}

.messageinfo {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  z-index: 1002;

  button {
    border: none;
    outline: none;
    background: linear-gradient(#e7e8e9, #babbbb);
    width: 2rem;
    height: 0.6rem;
    color: #666666;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }

  .usertext {
    width: 5rem;
    background: #ffffff;
    border-radius: 5px;
    font-size: 0.28rem;
    margin: 4rem auto;
    height: 3rem;
    padding: 0.2rem 0.4rem;
    box-sizing: border-box;
    display: flex;
    z-index: 1002 !important;
    flex-direction: column;
    justify-content: space-between;

    p:nth-of-type(2) {
      display: flex;
      justify-content: space-around;

      button:nth-of-type(2) {
        background: linear-gradient(#21afff, #007fff);
        color: #ffffff;
      }
    }
  }

  .reguserinfo {
    width: 6rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    margin: 3rem auto;
    padding: 0.3rem;

    ul {
      font-size: 0.24rem;
      padding: 0.3rem;
      box-sizing: border-box;

      li {
        text-align: left;
        margin-bottom: 0.2rem;

        input {
          width: 4rem;
          height: 0.5rem;
          padding: 0 0.2rem;
          box-sizing: border-box;
          outline: none;
        }

        .important {
          color: #c4171f;
        }
      }
    }

    p {
      display: flex;
      justify-content: space-around;
      padding: 0.2rem;
      box-sizing: border-box;

      button:nth-of-type(2) {
        background: #007eff;
        color: #ffffff;
      }
    }
  }
}

.showimg,
.sharecontent {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);

  img {
    width: 100%;
    margin-top: 2rem;
    z-index: 9999;
  }
}

.sharecontent > img {
  margin-top: 0;
}

#homeicon {
  position: absolute;
  bottom: 1.3rem;
  right: 0.3rem;
  width: 1rem;
  height: 1rem;
}

.people {
  display: flex;
  padding-left: 10px;
  justify-content: space-between;
  align-items: center;
  height: 42px;

  span:nth-of-type(1) {
    font-size: 12px;
  }
}

.member {
  background: rgba(0, 0, 0, 0.5);
  min-width: 100vw;
  min-height: 100vh;
  position: fixed !important;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 9999 !important;

  > div {
    width: 5rem;
    z-index: 10001 !important;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 0.16rem;
    margin: 4rem auto;
    height: 3.5rem;
    padding: 0.2rem 0.28rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ul {
      width: 100%;

      li:nth-of-type(1) {
        font-weight: bolder;
      }

      li:nth-of-type(2) {
        text-indent: 0.56rem;
        font-size: 0.28rem;
        margin-top: 0.2rem;
      }

      li {
        width: 100%;
        font-size: 0.28rem;
      }
    }

    > p {
      width: 100%;
      display: flex;
      justify-content: space-between;

      button {
        width: 2rem;
        height: 0.6rem;
        border: none;
        outline: none;
        background: linear-gradient(#e7e8e9, #babbbb);
        color: #333;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
      }

      a > button {
        color: #ffffff;
        background: linear-gradient(#21afff, #007fff);
      }
    }
  }
}

.winnerinfo {
  width: 100%;
  padding: 10px 20px 0px;
  box-sizing: border-box;
  font-size: 14px;
  white-space: pre-wrap;

  ul {
    overflow-y: scroll;
    height: 140px !important;
    padding: 0px 0.3rem 0px !important;
    line-height: 16px;
  }

  .title {
    display: block;
  }

  .none {
    text-align: center;
    height: 160px;
    line-height: 160px;
  }

  p {
    display: inline-block;

    span {
      text-align: center;
    }

    button {
      width: 150px;
      height: 35px;
      background: #ffb441;
      border: none;
      outline: none;
      color: #ffffff;
      border-radius: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/container/details.vue